import { useRecoilState } from 'recoil';

import t from "lib/i18n";
import useModal from "hooks/useModal";
import useLayout from "hooks/useLayout";
import useGTM from "hooks/useGTM";
import { trackFavouritesSelectFavouriteComplete } from "lib/tracking";
import { highlightedFavouriteTicket, selectedFavouriteTicket } from 'state';

import { TicketSelectionList } from "components/favourites/TicketSelection";
import Button, { ButtonColors, ButtonTypes } from 'components/ui/Button';
import { ReactComponent as CloseIcon } from "static/images/close.svg";
import SrOnly from 'components/helpers/SrOnly';

const TicketSelectionModal = () => {
  const { closeModal } = useModal();
  const { isMobile, isDesktop } = useLayout();
  const [highlightedTicket, setHighlightedTicket] = useRecoilState(highlightedFavouriteTicket);
  const [selectedTicket, setSelectedTicket] = useRecoilState(selectedFavouriteTicket);
  const dispatchGTM = useGTM();

  const onClose = () => {
    setHighlightedTicket(null);
    closeModal();
  };

  const onConfirm = () => {
    const newTicketSelected = highlightedTicket !== selectedTicket;
    if (newTicketSelected) {
      setSelectedTicket(highlightedTicket);
    }
    dispatchGTM(trackFavouritesSelectFavouriteComplete(
      (newTicketSelected ? highlightedTicket : selectedTicket).id
    ));
    onClose();
  };

  const baseClass = 'otrl-jp__ticket-selection-modal';

  return (
    <>
      <div className={`${baseClass}-title`}>
        <span aria-label={`${t('favourites.ticketSelection.list.header')}.`}>
          {t('favourites.ticketSelection.list.header')}
        </span>
        { isMobile && (
          <div
            className={`${baseClass}-title__close`}
            onClick={onClose}
            aria-hidden="true"
          >
            <CloseIcon />
            <SrOnly>{t('favourites.ticketSelection.close')}</SrOnly>
          </div>
        )}
      </div>
      <div className={`${baseClass}-body`}>
        <TicketSelectionList />
      </div>
      <div className={`${baseClass}-actions`}>
      { isDesktop && (
          <Button
            color={ButtonColors.SECONDARY}
            onClick={onClose}
          >
            {t('favourites.ticketSelection.close')}
          </Button>
        )}
        <Button
          type={ButtonTypes.SUBMIT}
          onClick={onConfirm}
          ariaLabel={t('favourites.ticketSelection.confirm.aria')}
        >
          {t('favourites.ticketSelection.confirm')}
        </Button>
      </div>
    </>
  );
};

export default TicketSelectionModal;
